module.exports = __webpack_public_path__ + "3899920490d0d1775f0b6d56220ea04b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatext/KOMTXT.woff
// module id = 403
// module chunks = 0